<template>
  <div :class="`combatant-list-item f ${combatant.isPC ? 'pc' : 'npc'}`">
    <div class="f">
      <div class="f-as w-x36">
        <div>
          <div class="t-18 fw-6">{{ combatant.name }}</div>
          <div class="t-10 m-tx2">{{ description }}</div>
          <div v-if="alignment" class="t-10 m-tx1">{{ alignment }}</div>
        </div>
      </div>

      <div v-if="combatant.isPC" class="f-as w-x40 m-lx4">
        <div class="f-ac">
          <div class="t fw-6 m-rx1">Initiative:</div>
          <input type="number" v-model="initiative" class="input-text h-x3 w-x12">
        </div>
      </div>
      <div v-else class="f-v w-x40 m-lx4">
        <div>
          <div v-if="initiative || initiative === 0" class="f-ac f-sb w-x36 h-x6">
            <div class="t fw-6">Initiative:</div>
            <div class="t fw-6">{{ initiative }}</div>
          </div>
          <button v-else class="button bg-white h-x6 t-10 w-x36" @click="rollInitiatve">Roll Initiative ({{ initiativeDice }})</button>
        </div>
        <div class="m-tx2">
          <div v-if="hp || hp === 0" class="f-ac f-sb w-x36">
            <div class="t fw-6 m-rx1">Hit Points:</div>
            <input type="number" v-model="hp" class="input-text h-x3 w-x12">
          </div>
          <button v-else class="button bg-white h-x6 t-10 w-x36" @click="rollHP">Roll HP ({{ hpDice }})</button>
        </div>
      </div>
  
      <textarea
        v-model="notes"
        class="input-text resizable t-10 w-x48 h-x3 min-h-x3"
        placeholder="Notes"
        tabindex="1"
      ></textarea>
    </div>
    <div v-if="!combatant.isPC" class="w-100p f-je">
      <button class="button bg-white w-x6 h-x6 t-10" @click="inspect">
        <span class="material-symbols-outlined t-18"> search </span>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';
  const props = defineProps(['uuid']);

  const store = useCombatEncounterStore();

  const combatant = computed(() => store.combatants.find(c => c.uuid === props.uuid));
  const description = computed(() => {
    if (combatant.value.isPC) return 'Player character';
    return combatant.value.size + ' ' + combatant.value.type;
  });
  const alignment = computed(() => {
    if (combatant.value.isPC) return;
    return combatant.value.alignment.charAt(0).toUpperCase() + combatant.value.alignment.slice(1);
  })
  const inspect = () => {
    store.inspectCombatant(combatant.value);
  };

  // Hit Points
  const hp = computed({
    get() { return combatant.value.hp },
    set(val) { updateHP(val) },
  });
  const updateHP = (value) => {
    store.updateCombatant({ uuid: combatant.value.uuid, key: 'hp', value });
  };
  const hpDice = computed(() => combatant.value.hit_points_roll);
  const rollHP = () => {
    store.rollDice({ title: `Hit Points: ${combatant.value.name}`, dice: hpDice.value })
      .then(result => updateHP(result));
  };

  // Initiative
  const initiative = computed({
    get() { return combatant.value.initiative },
    set(val) { updateInitiative(val) },
  });
  const updateInitiative = (value) => {
    store.updateCombatant({ uuid: combatant.value.uuid, key: 'initiative', value });
  };
  const initiativeDice = computed(() => {
    const dexModifier = Math.floor((combatant.value.dexterity - 10) / 2.0)
    return `1d20 + ${dexModifier}`;
  });
  const rollInitiatve = () => {
    store.rollDice({ title: `Initiative: ${combatant.value.name}`, dice: initiativeDice.value })
      .then(result => updateInitiative(result));
  };

  // Notes
  const notes = computed({
    get() { return combatant.value.notes },
    set(value) { store.updateCombatant({ uuid: combatant.value.uuid, key: 'notes', value }) },
  });
</script>